import { useZionAxios } from '@fs/zion-axios'

export default function useIsAdmin() {
  const [{ data, error, loading }] = useZionAxios({
    url: '/service/ident/cas/cas-public-api/authorizations/contexts/eurona.travelsites.context.All/permissions/eurona.travelsites.perm.Admin',
    method: 'get',
  })

  return { data, error, loading }
}
